import React, { Fragment } from 'react'
import PT from 'prop-types'

import asset from 'utils/asset'

import { Avatar, Description, Message, Title } from './styled'

function OrderPartyDesc({
  name = 'Order Party',
  leaderCustomerImage = '',
  description = 'No description is available',
}) {
  return (
    <Fragment>
      <Avatar
        style={{
          backgroundImage: `url(${leaderCustomerImage ||
            asset('images/avatar.png')})`,
        }}
      />
      <Description>
        <Title color="white" variant="body">
          {name}
        </Title>
        <Message title={description} variant="tiny" color="white">
          {description}
        </Message>
      </Description>
    </Fragment>
  )
}

OrderPartyDesc.propTypes = {
  name: PT.string,
  leaderCustomerImage: PT.string,
  description: PT.string,
}

export default OrderPartyDesc
